import { useTypedApiClient } from 'hooks/useTypedApiClient'
import { useMutation, useQueryClient } from '@tanstack/react-query'

interface UseDeleteResourceParams {
  id: number | null | undefined
}

interface UseDeleteResourceProps {
  onSuccess?: (data: undefined, variables: UseDeleteResourceParams) => void
  onError?: (error: Error, variables: UseDeleteResourceParams) => void
}

export const useDeleteResourceById = ({
  onSuccess,
  onError,
}: UseDeleteResourceProps) => {
  const deleteResource = useTypedApiClient({
    path: '/admin/resources/{id}',
    method: 'delete',
  })
  const queryClient = useQueryClient()

  return useMutation<any, Error, UseDeleteResourceParams>({
    mutationFn: async ({ id }: UseDeleteResourceParams) => {
      await deleteResource({ id: Number(id) })
    },
    onSuccess: async (data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: ['/admin/resources'],
      })
      onSuccess?.(data, variables)
    },
    onError,
  })
}
